import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getHitomiDetail, updateHitomi } from '@/repository/hitomi';
import { Hitomi } from '@/model/hitomi';
import { useStore } from 'vuex';
import { HttpStatusCode } from 'axios';
import HitomiInformation from '@/components/disposable/HitomiInformation.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateHitomiView',
  setup(__props) {

const hitomiUUID = useRoute().params.hitomiUUID as string;
const router = useRouter();
const store = useStore();

let initHitomi: Hitomi = {
	hitomiTitle: '',
	hitomiImageURL: '',
	hitomiLink: '',
	hitomiArtists: [],
	hitomiGroups: [],
	hitomiTags: [],
	isFavorite: false
};

onMounted(async () => {
	const res = await getHitomiDetail(hitomiUUID);
	if (res) {
		initHitomi = res;
		hitomi.value = { ...initHitomi };
	} else {
		isFound.value = false;
	}
	isLoading.value = false;
});

const isFound = ref(true);
const isLoading = ref(true);
const hitomi = ref<Hitomi>({ ...initHitomi });
async function saveHitomi(isRedirect: boolean, data: Hitomi) {
	hitomi.value = data;
	try {
		isLoading.value = true;
		if (hitomi.value) {
			// DISABLED UPLOAD
			const res = await updateHitomi(hitomi.value);
			if (res.status === HttpStatusCode.Ok) {
				store.dispatch('alert', { type: 'success', message: 'update hitomi successfully!' });
				if (isRedirect) {
					isLoading.value = false;
					await router.push({ name: 'Hitomi' });
					return;
				}
				initHitomi = { ...hitomi.value };
			} else if (res.status === HttpStatusCode.BadRequest) {
				throw res.error?.error;
			} else if (res.status === HttpStatusCode.Conflict) {
				throw Error('this hitomi is already exists!');
			}
		}
		throw Error('image is required');
	} catch (error) {
		store.dispatch('alert', {
			type: 'error',
			message: `${error}` || 'something went wrong, please try again!'
		});
	} finally {
		isLoading.value = false;
	}
}

return (_ctx: any,_cache: any) => {
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isFound.value)
      ? (_openBlock(), _createBlock(HitomiInformation, {
          key: 0,
          hitomi: hitomi.value,
          "is-loading": isLoading.value,
          onReset: _cache[0] || (_cache[0] = () => (hitomi.value = { ..._unref(initHitomi) })),
          onSubmit: saveHitomi
        }, null, 8, ["hitomi", "is-loading"]))
      : (_openBlock(), _createBlock(_component_a_empty, {
          key: 1,
          class: "!text-white my-2 sm:my-4"
        }))
  ]))
}
}

})